// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sectiontitle_sectionTitle__l0WQ5"};